import { AlertContainer } from '@oneflare/flarekit/lib/components';
import { createRef } from 'react';

export const globalAlertContainer = createRef<AlertContainer>(); 